import { IDestination, IPolicy, IStateCities, ITraveller } from '../../data/api/models';

export interface IMtaAction {
  type: string;
  payload?: any;
}

export interface IMtaState {
  selectedPolicy: IPolicy;
  policyInfo: {
    meta: {
      termNumber: number;
      hasRenewal: boolean;
      isInCoolingOff: boolean;
    }
  };
  paymentMethod: {
    maskedPAN: string;
    id: string;
  }
  rules: {
    canUpsell: boolean
  }
  mtaQuote: any;
  coverDetails: {
    selectedMta: string;
  };
  quotes: {};
  signpost: { isSignposted: boolean, isMedical: boolean };
  paymentModal: {open: boolean, transactionId: string};
  destinations: IDestination[],
  stateCities: IStateCities[],
  isLoading: boolean;
  complete: boolean;
  afterSubmit: {
    changes: {};
    policyId: string;
    success: boolean;
    error: string;
  };
}

export interface IPersonalDetailsForm {
  policyId?: string;
  travellers?: ITraveller[];
}

export enum IMtaFormNames {
  PERSONAL_DETAILS = 'personal-details',
  COVER_DETAILS = 'cover-details',
  CANCEL_FORM = 'cancel-form'
}

export const enum PageForm {
  MTA_DECLARATION = 'MTADeclaration',
  MTA_CHANGE_DESTINATION = 'MTAChangeDestination',
  MTA_CHANGE_TRIP_DATES = 'MTAChangeTripDates',
  MTA_ADDITIONAL_COVER = 'MTAAdditionalCover',
  MTA_ADDITIONAL_TRAVELLERS = 'MTAAdditionalTravellers',
  MTA_REMOVE_TRAVELLER = 'MTARemoveTraveller',
  MTA_CHANGE_TIER = 'MTAChangeTier',
  MTA_CHANGE_REGION = 'MTAChangeRegion',
  MTA_CHANGE_TRIP_TYPE = 'MTAChangeTripType',
  MTA_MEDICAL_DECLARATION = 'MTAMedicalDeclaration',
  MTA_SUMMARY = 'MTASummaryForm',
  MTA_CANCEL = 'MTACancelForm'
}

export interface ICoverDetailsForm {
  page: string;
  coverDetailsDeclaration?: boolean;
  isUpsell?: boolean;
  data: any;
}

export interface IMtaActions {
  submitPersonalDetailsForm();
  storeMtaPolicyApplication(mtaForm);
  setSelectedPolicy(Policy);
  setSelectedMta(mtaName);
  handleMTASubmit(redirectUrl?);
  calculateMtaPremiums(mtaForm?);
  resetMtaData();
  getSelectedScheme();
  resetAfterSubmit();
  setCompleteMTA();
  getCustomerMtaOptions();
  setSignPost(data);
  getCustomerPolicyPaymentMethod();
  getPolicyInfo();
  recalculateScreening(selection, type);
  addEndorsements();
  loadDestinations();
  loadStateCities();
  getDetailsForCancellation(policyId);
  cancelPolicy(formValues, policyId);
  setUpsellRules(canUpsell);
}
